const data = {
	"width": 20,
	"height": 20,
	"body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M16.707 5.293a1 1 0 0 1 0 1.414l-8 8a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L8 12.586l7.293-7.293a1 1 0 0 1 1.414 0Z\" clip-rule=\"evenodd\"/>"
};
export default data;
